import { Select } from '@bloomfieldrobotics/canopy';
import { useMemo } from 'react';
import { useLanguages } from '../../../../services/translation/hooks/useLanguages';

type Props = {
  value: string;
  onChange: (language: string) => void;
};

export const NativeLanguageSelectionDropdown = ({ value, onChange }: Props) => {
  const languages = useLanguages();

  const languageOptions = useMemo(
    () =>
      Object.entries(languages).map(([languageCode, language]) => ({
        label: language.nativeName,
        value: languageCode,
      })),
    [languages]
  );

  return (
    <Select
      options={languageOptions}
      value={value}
      onChange={onChange}
      menuAlignment='right'
    />
  );
};
